<script lang="ts">
	// Stands in for svelte-loading-spinners' `Circle`, keeping its prop API so call sites only
	// changed their import. That package ships raw .svelte files, declares no peer range at all,
	// and has not been published since Svelte 4.
	interface Props {
		color?: string;
		size?: string;
		unit?: string;
		duration?: string;
	}

	let { color = "#FF3E00", size = "60", unit = "px", duration = "0.75s" }: Props = $props();
</script>

<div class="spinner" style="--spinner-size: {size}{unit}; --spinner-color: {color}; --spinner-duration: {duration}"></div>

<style lang="scss">
	.spinner {
		height: var(--spinner-size);
		width: var(--spinner-size);
		border-color: var(--spinner-color) transparent var(--spinner-color) var(--spinner-color);
		border-width: calc(var(--spinner-size) / 15);
		border-style: solid;
		border-radius: 50%;
		animation: spinner-rotate var(--spinner-duration) linear infinite;
	}

	// A reader who asked for less motion still needs to know something is loading.
	@media (prefers-reduced-motion: reduce) {
		.spinner {
			animation-duration: 2s;
		}
	}

	@keyframes spinner-rotate {
		to {
			transform: rotate(360deg);
		}
	}
</style>
